import styled from 'styled-components';

export const Conteudo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px;

  /* faz os controles nativos (checkbox, scrollbar) seguirem o tema */
  color-scheme: ${({ theme }) => (theme.isDark ? 'dark' : 'light')};
`;

export const Explicacao = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.gray};

  strong {
    color: ${({ theme }) => theme.textColor};
  }
`;

export const Tabela = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th {
    text-align: left;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    padding: 8px 10px;
    background-color: ${({ theme }) => theme.tableHeaderBackground};
    color: ${({ theme }) => theme.tableHeaderText};
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  }

  td {
    padding: 9px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
    color: ${({ theme }) => theme.textColor};
  }

  tbody tr:hover {
    background-color: ${({ theme }) => theme.tableHoverBackground};
  }
`;

export const Vazio = styled.div`
  padding: 18px;
  text-align: center;
  font-size: 13px;
  color: ${({ theme }) => theme.gray};
  background-color: ${({ theme }) => theme.lightColor};
  border-radius: 8px;
`;

export const Mono = styled.span`
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
  color: ${({ theme }) => theme.textColor};
`;

export const AcoesLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
`;

export const PropagarButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.lightColor};
  color: ${({ theme }) => theme.textColor};

  &:hover {
    background-color: ${({ theme }) => theme.primaryColor};
    border-color: ${({ theme }) => theme.primaryColor};
    color: #fff;
  }
`;

export const RevogarButton = styled.button`
  padding: 5px 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  background-color: ${({ theme }) => theme.dangerLightColor};
  color: ${({ theme }) => (theme.isDark ? '#ffb4b4' : '#b91c1c')};

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.dangerColor};
    color: #fff;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Rodape = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 14px;
  border-top: 1px solid ${({ theme }) => theme.borderColor};
`;

export const CheckboxLinha = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: fit-content;
  font-size: 13px;
  color: ${({ theme }) => theme.textColor};
  cursor: pointer;
  user-select: none;

  /*
   * O globalStyles aplica input { width: 100%; padding: 10px; border: ... },
   * o que estica o checkbox pela linha inteira: o glifo fica centralizado e o
   * texto e empurrado para a ponta. Aqui o checkbox volta ao tamanho dele.
   */
  input[type='checkbox'] {
    flex: 0 0 auto;
    width: 16px;
    min-width: 16px;
    height: 16px;
    margin: 0;
    padding: 0;
    border-radius: 3px;
    accent-color: ${({ theme }) => theme.primaryColor};
    cursor: pointer;
  }
`;

export const GerarButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }
`;

/**
 * Caixa da chave recém-gerada. Verde quando foi gravada no ERP, vermelha
 * quando não foi — nos dois temas, com fundo próprio para cada um: os tokens
 * successColor/dangerColor do tema escuro são escuros demais para servir de
 * fundo com texto por cima.
 */
export const ChaveGeradaBox = styled.div<{ $erro?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $erro }) =>
      $erro
        ? theme.isDark
          ? '#7f3030'
          : '#fca5a5'
        : theme.isDark
        ? '#2f6b45'
        : '#86efac'};
  background-color: ${({ theme, $erro }) =>
    $erro
      ? theme.isDark
        ? '#3a1f1f'
        : '#fef2f2'
      : theme.isDark
      ? '#1e3a2a'
      : '#f0fdf4'};
`;

export const ChaveValor = styled.code`
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
  font-size: 13px;
  word-break: break-all;
  padding: 8px 10px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.inputBackground};
  border: 1px solid ${({ theme }) => theme.borderColor};
  color: ${({ theme }) => theme.textColor};
`;

export const Atencao = styled.strong`
  font-size: 13px;
  color: ${({ theme }) => (theme.isDark ? '#7ee2a8' : '#166534')};
`;

export const AtencaoErro = styled.strong`
  font-size: 13px;
  color: ${({ theme }) => (theme.isDark ? '#ffb4b4' : '#b91c1c')};
`;
